<template>
  <div>
    <a-drawer
      title="租船合同修改内容"
      placement="right"
      :closable="true"
      :visible="visible"
      :mask="false"
      width="500"
      @close="closeDrawer"
    >
      <a-spin :spinning="loading">
        <span v-for="(record, index) in commonContractRecordList" :key="index">
          <span class="desc" v-if="parseCommonContractRecord(record['modify_record'])['contract_name']">合同名称：{{ parseCommonContractRecord(record['modify_record'])['contract_name']['before'] }} -> {{ parseCommonContractRecord(record['modify_record'])['contract_name']['after'] }}</span>
          <span class="desc" v-if="parseCommonContractRecord(record['modify_record'])['shipping_company']">运输公司名称：{{ parseCommonContractRecord(record['modify_record'])['shipping_company']['before'] }} -> {{ parseCommonContractRecord(record['modify_record'])['shipping_company']['after'] }}</span>
          <span class="desc" v-if="parseCommonContractRecord(record['modify_record'])['demurrage_terms']">滞期费规定：{{ parseCommonContractRecord(record['modify_record'])['demurrage_terms']['before'] }} -> {{ parseCommonContractRecord(record['modify_record'])['demurrage_terms']['after'] }}</span>
          <span class="desc" v-if="parseCommonContractRecord(record['modify_record'])['despatch_terms']">速遣费规定：{{ parseCommonContractRecord(record['modify_record'])['despatch_terms']['before'] }} -> {{ parseCommonContractRecord(record['modify_record'])['despatch_terms']['after'] }}</span>
          <span class="desc" v-if="parseCommonContractRecord(record['modify_record'])['payment_method']">支付方式：
            {{ dictionaries.trade_payment_method[parseCommonContractRecord(record['modify_record'])['payment_method']['before']] }} -> {{ dictionaries.trade_payment_method[parseCommonContractRecord(record['modify_record'])['payment_method']['after']] }}
          </span>
          <span class="desc" v-if="parseCommonContractRecord(record['modify_record'])['billing_method']">计费方式：{{ parseCommonContractRecord(record['modify_record'])['billing_method']['before'] }} -> {{ parseCommonContractRecord(record['modify_record'])['billing_method']['after'] }}</span>
          <span class="desc" v-if="parseCommonContractRecord(record['modify_record'])['payment_cycle']">支付周期：{{ parseCommonContractRecord(record['modify_record'])['payment_cycle']['before'] }} -> {{ parseCommonContractRecord(record['modify_record'])['payment_cycle']['after'] }}</span>
          <span class="desc" v-if="parseCommonContractRecord(record['modify_record'])['tax_rate']">税率：{{ parseCommonContractRecord(record['modify_record'])['tax_rate']['before'] }}% -> {{ parseCommonContractRecord(record['modify_record'])['tax_rate']['after'] }}%</span>
        </span>
      </a-spin>
    </a-drawer>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import { common_contract_record_list } from '@/api/trade_contract'

export default {
  name: 'CharterPartyContractRecord',
  props: {
    contract: {
      type: Object,
      default () {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parseCommonContractRecord () {
      return (record) => {
        return JSON.parse(record)
      }
    },
    leaseDatePeriodBefore () {
      return (record) => {
        const before_start_date = record['lease_start_date']['before'] === '1970-01-01' ? undefined : record['lease_start_date']['before']
        const before_end_date = record['lease_end_date']['before'] === '1970-01-01' ? undefined : record['lease_end_date']['before']
        if (before_start_date && before_end_date) {
          return before_start_date + '~' + before_end_date
        } else {
          return '无'
        }
      }
    },
    leaseDatePeriodAfter () {
      return (record) => {
        const after_start_date = record['lease_start_date']['after'] === '1970-01-01' ? undefined : record['lease_start_date']['after']
        const after_end_date = record['lease_end_date']['after'] === '1970-01-01' ? undefined : record['lease_end_date']['after']
        if (after_start_date && after_end_date) {
          return after_start_date + '~' + after_end_date
        } else {
          return '无'
        }
      }
    }
  },
  data () {
    return {
      loading: false,
      dictionaries: Dictionaries,
      commonContractRecordList: []
    }
  },
  mounted () {
    this.loadModifyRecord()
  },
  methods: {
    closeDrawer () {
      this.$emit('close')
    },
    loadModifyRecord () {
      this.loading = true
      common_contract_record_list({ contract_number: this.contract.contract_number, contract_type: this.contract_type, to_version: this.contract.version }).then(res => {
        if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
          this.commonContractRecordList = res.data.entries || []
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: block;
}
</style>
